/* eslint-disable @typescript-eslint/ban-ts-comment */
import * as React from 'react'
import tw from 'tailwind-styled-components'

type TextProps = {
  /** Text is active */
  $active?: boolean
  /** Text is bold */
  $bold?: boolean
  /** Text is large */
  $large?: boolean
  /** Text is light */
  $light?: boolean
  /** Text is xlight */
  $xlight?: boolean
  /** Text is medium */
  $medium?: boolean
  /** Text is medium large */
  $mediumLarge?: boolean
  /** Text is muted */
  $muted?: boolean
  /** Text is red */
  $red?: boolean
  /** Text is green */
  $green?: boolean
  /** Text is semibold */
  $semibold?: boolean
  /** Text is small */
  $small?: boolean
  /** Text is truncated */
  $truncate?: boolean
  /** Text is txt */
  $txt?: boolean
  /** Text is xsmall */
  $xlarge?: boolean
  /** Text is xsmall */
  $xsmall?: boolean
  /** Text is inline */
  $inline?: boolean
  /** Text className */
  className?: string
}

const StyledText = tw.p<TextProps>`
  ${(props) => {
    // SIZE
    if (props.$xsmall) return 'text-xs'

    if (props.$small) return 'text-sm'

    if (props.$mediumLarge) return 'text-lg'

    if (props.$large) return 'text-xl'

    if (props.$xlarge) return 'text-4xl'

    return 'text-base'
  }}

  ${(props) => {
    // COLOR
    if (props.$muted) return 'text-gray-300'

    if (props.$light) return 'text-gray-500'

    if (props.$xlight) return 'text-gray-400'

    if (props.$active) return 'text-zentake'

    if (props.$txt) return 'text-txt'

    if (props.$red) return 'text-red-500'

    if (props.$green) return 'text-green-500'

    return 'text-gray-700'
  }}

  ${(props) => {
    // WEIGHT
    if (props.$bold) return 'font-bold'

    if (props.$medium) return 'font-medium'

    if (props.$semibold) return 'font-semibold'

    return 'font-normal'
  }}

  ${(props) => (props.$truncate ? 'truncate' : '')}

  ${(props) => (props.$inline ? 'inline' : '')}

  p-0
`

/** Text component */
const Text = ({
  children,
  ...props
}: React.PropsWithChildren<TextProps>): JSX.Element => (
  // @ts-ignore
  <StyledText {...props}>{children}</StyledText>
)

export default Text
